var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{ref:"regionalQuota",attrs:{"table-code":"regionalQuota","menus":['查询', '批量修改', '插入', '批量删除'],"bottomFrozenRowCount":1,"columns":_vm.columns,"data":_vm.tableData,"loading":_vm.loading},on:{"modify-data-change":_vm.onModifyDataChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }